import React from 'react';
import { LuCheckCircle, LuXCircle, LuLoader } from 'react-icons/lu';

import './Toast.scss';

const ICONS = {
    success: <LuCheckCircle />,
    error: <LuXCircle />,
    loading: <LuLoader className='spin' />,
};

const Toast = ({ toast }) => (
    <div className={`toast ${toast ? 'is-visible' : ''} ${toast ? `toast--${toast.type}` : ''}`}>
        {toast && (
            <>
                <span className='toast-icon'>{ICONS[toast.type]}</span>
                <p>{toast.message}</p>
            </>
        )}
    </div>
);

export default Toast;
